import categories from "../data/features";

export default function Features() {
  return (
    <section id="fonctionnalites" className="bg-mist/60 py-20 sm:py-28">
      <div className="mx-auto max-w-content px-5 sm:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
            Une application, tous vos outils réunis
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft">
            Hygio regroupe ce qui nécessitait auparavant plusieurs
            applications différentes : la gestion de votre équipe, votre
            conformité HACCP, vos stocks et achats, votre caisse et le
            pilotage global de votre commerce.
          </p>
        </div>

        <div className="mt-14 space-y-14">
          {categories.map((category) => (
            <div key={category.name}>
              <h3 className="text-sm font-semibold uppercase tracking-wide text-accent-dark">
                {category.name}
              </h3>
              <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {category.features.map(({ icon: Icon, title, description }) => (
                  <div
                    key={title}
                    className="group rounded-2xl border border-ink/[0.06] bg-white p-6 shadow-softer transition-shadow hover:shadow-soft"
                  >
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-accent-light text-accent-dark">
                      <Icon size={20} strokeWidth={2} />
                    </div>
                    <h4 className="mt-4 text-[15px] font-semibold text-ink">
                      {title}
                    </h4>
                    <p className="mt-2 text-[14.5px] leading-relaxed text-ink-soft">
                      {description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
